import React, { useState, useEffect } from "react";
import { API, UPLOADS } from "./../../config/api";
import { useLocation } from "react-router-dom";
export default function Pendingworkspace() {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [workspaces, setWorkspaces] = useState([]);
  const [statusFilter, setStatusFilter] = useState(
    location.state?.status || "All",
  );
  useEffect(() => {
    if (location.state?.status) {
      setStatusFilter(location.state.status);
    }
  }, [location.state]);
  // Single search input state
  const [searchQuery, setSearchQuery] = useState("");

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentImage, setPaymentImage] = useState("");

  // States for the image sliding popup
  const [showCarousel, setShowCarousel] = useState(false);
  const [carouselImages, setCarouselImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  useEffect(() => {
    fetchWorkspaces();
  }, [statusFilter]);

  // Keyboard navigation for the image carousel
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!showCarousel) return;
      if (e.key === "ArrowRight") handleNextImage();
      if (e.key === "ArrowLeft") handlePrevImage();
      if (e.key === "Escape") setShowCarousel(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showCarousel, currentImageIndex, carouselImages]);

  const fetchWorkspaces = async () => {
    try {
      let url = `${API.BASE_URL}/api.php?action=list_workspaces_status`;

      if (statusFilter !== "All") {
        url += `&status=${statusFilter}`;
      }

      const res = await fetch(url);
      const data = await res.json();
      setWorkspaces(data.data || data);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const formatDate = (date) => {
    if (!date || date === "0000-00-00 00:00:00") {
      return "-";
    }

    const d = new Date(date);
    if (isNaN(d.getTime())) {
      return "-";
    }

    return (
      <>
        <div className="fw-bold">{d.toLocaleDateString()}</div>
        <div className="text-muted small">
          {d.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      </>
    );
  };

  const handleView = (workspace) => {
    setSelectedWorkspace(workspace);
    setShowModal(true);
  };

  const [renewModal, setRenewModal] = useState({
    open: false,
    workspace: null,
    days: 30,
  });

  const openRenewModal = (workspace) => {
    setRenewModal({
      open: true,
      workspace,
      days: workspace.show_ads_days || 30,
    });
  };

  const renewWorkspaceAdvertisement = async () => {
    try {
      const fd = new FormData();
      fd.append("id", renewModal.workspace.id);
      fd.append("days", renewModal.days);
      fd.append("amount", renewModal.workspace.ads_amount || 0);

      const res = await fetch(
        `${API.BASE_URL}/api.php?action=renew_workspace_ads`,
        {
          method: "POST",
          body: fd,
        },
      );

      const data = await res.json();
      alert(data.message);

      if (data.status) {
        setRenewModal({
          open: false,
          workspace: null,
          days: 30,
        });
        fetchWorkspaces();
      }
    } catch (err) {
      console.error(err);
      alert("Renew error");
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setShowPaymentModal(false);
  };

  const updateStatus = async (status) => {
    if (status === "Rejected") {
      const confirmDelete = window.confirm(
        "Are you sure? Rejecting this workspace will permanently delete it and all its uploaded images.",
      );
      if (!confirmDelete) return;
    }

    try {
      const formData = new FormData();
      formData.append("id", selectedWorkspace.id);

      if (status !== "Rejected") {
        formData.append("status", status); // Active or Hidden
      }

      const apiUrl =
        status === "Rejected"
          ? API.DELETE_WORKSPACE
          : API.UPDATE_WORKSPACE_STATUS;

      const res = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      alert(data.message);

      setShowModal(false);
      fetchWorkspaces();
    } catch (error) {
      console.error("Operation Error:", error);
    }
  };

  // Carousel controls
  const openCarousel = (imagesString, startIndex) => {
    const imagesArray = imagesString.split(",").map((img) => img.trim());
    setCarouselImages(imagesArray);
    setCurrentImageIndex(startIndex);
    setShowCarousel(true);
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % carouselImages.length);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex(
      (prev) => (prev - 1 + carouselImages.length) % carouselImages.length,
    );
  };

  // Client-side filtration through a single smart search query
  const filteredWorkspaces = workspaces.filter((item) => {
    if (!searchQuery.trim()) return true;

    const query = searchQuery.toLowerCase().trim();

    const matchesName = item.owner_name?.toLowerCase().includes(query);
    const matchesPhone = item.phone?.toLowerCase().includes(query);
    const matchesUserId = item.user_id
      ?.toString()
      .toLowerCase()
      .includes(query);
    const matchesEmail = item.email?.toLowerCase().includes(query);

    // Return true if any of the fields match the text query
    return matchesName || matchesPhone || matchesUserId || matchesEmail;
  });

  const paginatedWorkspaces = filteredWorkspaces.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <div className="dashboard-content">
      <style>{`
        .filter-container {
          display: flex;
          align-items: center;
          gap: 16px;
          background-color: #ffffff;
          padding: 18px 20px;
          border-radius: 10px;
          margin-bottom: 24px;
          border: 1px solid #e9ecef;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
        }
        .filter-group-status {
          flex: 0 0 200px;
          display: flex;
          flex-direction: column;
        }
        .filter-group-search {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .filter-label {
          font-size: 11px;
          font-weight: 700;
          color: #6c757d;
          margin-bottom: 6px;
          text-transform: uppercase;
          letter-spacing: 0.8px;
        }
        .filter-input {
          padding: 10px 14px;
          border: 1px solid #ced4da;
          border-radius: 8px;
          font-size: 14px;
          background-color: #fff;
          outline: none;
          transition: all 0.2s ease-in-out;
          color: #495057;
        }
        .filter-input:focus {
          border-color: #0d6efd;
          box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.15);
        }
        @media (max-width: 768px) {
          .filter-container {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
            padding: 15px;
          }
          .filter-group-status {
            flex: 1 1 auto;
          }
        }
      `}</style>

      <div
        style={{
          display: "flex",
          justifycontent: "space-between",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >
        <h2 className="machine-title">{statusFilter} Workspace Requests</h2>
      </div>

      {/* UNIFIED FILTER AND SMART SEARCH BAR */}
      <div className="filter-container">
        <div className="filter-group-status">
          <label className="filter-label">Filter Status</label>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="filter-input"
          >
            <option value="All">All Requests</option>
            <option value="Pending">Pending</option>
            <option value="Active">Active</option>
            <option value="Hide">Hide</option>
          </select>
        </div>

        <div className="filter-group-search">
          <label className="filter-label">Search Workspace</label>
          <input
            type="text"
            className="filter-input"
            placeholder="Search by Name, Mobile, User ID, or Email..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      <div className="table-responsive">
        <table className="machine-table">
          <thead>
            <tr>
              <th>#</th>
              <th>User Id</th>
              <th>Date</th>
              <th>Owner</th>
              <th>Ads</th>
              <th>Active Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredWorkspaces.length > 0 ? (
              paginatedWorkspaces.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    {filteredWorkspaces.length -
                      ((currentPage - 1) * itemsPerPage + index)}
                  </td>

                  <td data-label="user id">{item.user_id}</td>
                  <td>{formatDate(item.created_at)}</td>
                  <td>
                    <div className="fw-bold">{item.owner_name}</div>
                    <div className="text-muted small">{item.phone}</div>
                    {item.email && (
                      <div
                        className="text-muted small"
                        style={{ fontSize: "11px" }}
                      >
                        {item.email}
                      </div>
                    )}
                  </td>
                  <td>
                    <div className="fw-bold">
                      {item.show_ads_days || 0} Days
                    </div>
                    <div className="text-muted small">
                      ₹{item.ads_amount || 0}
                    </div>

                    {(() => {
                      if (item.status === "Pending") {
                        return (
                          <div
                            className="status-badge pending"
                            style={{
                              marginTop: 4,
                              display: "inline-block",
                              fontSize: "10px",
                              padding: "2px 6px",
                            }}
                          >
                            Pending
                          </div>
                        );
                      }

                      const expired = new Date(item.ads_end_date) < new Date();

                      return (
                        <span
                          className={`status-badge ${expired ? "hide" : "active"}`}
                          style={{
                            marginTop: 4,
                            display: "inline-block",
                            fontSize: "10px",
                            padding: "2px 6px",
                          }}
                        >
                          {expired ? "Expired" : "Running"}
                        </span>
                      );
                    })()}
                  </td>
                  <td>
                    {item.status === "Pending"
                      ? "-"
                      : formatDate(item.ads_start_date)}
                  </td>
                  <td>
                    {item.status === "Pending"
                      ? "-"
                      : formatDate(item.ads_end_date)}
                  </td>
                  <td data-label="Status">
                    <span
                      className={`status-badge ${
                        item.status === "Pending"
                          ? "pending"
                          : item.status === "Active"
                            ? "active"
                            : "hide"
                      }`}
                    >
                      {item.status === "Hidden" ? "Hide" : item.status}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      {(() => {
                        const isExpired =
                          item.ads_end_date &&
                          new Date(item.ads_end_date) < new Date();

                        return (
                          <>
                            <div className="action-buttons">
                              {item.status === "Pending" &&
                                Number(item.workspace_free_plan_used) === 1 && (
                                  <button
                                    className="renew-icon-btn"
                                    onClick={() => openRenewModal(item)}
                                    title="Renew Ads"
                                  >
                                    <i className="bi bi-arrow-repeat"></i>
                                  </button>
                                )}
                              {item.status === "Hidden" && isExpired && (
                                <button
                                  className="renew-icon-btn"
                                  onClick={() => openRenewModal(item)}
                                >
                                  <i className="bi bi-arrow-repeat"></i>
                                </button>
                              )}
                              <button
                                className="view-icon-btn"
                                onClick={() => handleView(item)}
                                title="View"
                              >
                                <i className="bi bi-eye-fill"></i>
                              </button>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center py-4">
                  No matching workspace requests found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* POPUP MODAL */}
      {showModal && selectedWorkspace && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>🏢 Workspace Review</h3>
            </div>

            <div className="popup-grid">
              <div>
                <label>Owner</label>
                <p>{selectedWorkspace.owner_name || "-"}</p>
              </div>
              <div>
                <label>Mobile No</label>
                <p>{selectedWorkspace.phone || "-"}</p>
              </div>
              <div>
                <label>City/State</label>
                <p>
                  {selectedWorkspace.city || "-"},{" "}
                  {selectedWorkspace.state || "-"}
                </p>
              </div>
              <div>
                <label>Room Size</label>
                <p>{selectedWorkspace.size || "-"} </p>
              </div>
              <div>
                <label>Floor</label>
                <p>{selectedWorkspace.floor || "-"}</p>
              </div>
              <div>
                <label>Rent Price</label>
                <p>
                  ₹{" "}
                  {Number(selectedWorkspace.rent_price).toLocaleString("en-IN")}
                </p>
              </div>
              <div>
                <label>Location</label>
                <p>{selectedWorkspace.location || "-"}</p>
              </div>

              <div>
                <label>Ads Duration</label>
                <p>{selectedWorkspace.show_ads_days || "-"}</p>
              </div>

              <div>
                <label>Payed Amount:</label>
                <p>₹{selectedWorkspace.ads_amount || 0}</p>
              </div>

              {selectedWorkspace.payment_screenshot ? (
                <div className="payment-proof-section">
                  <label>Payment Screenshot</label>
                  <div
                    className="popup-images"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setPaymentImage(
                        `${UPLOADS.WORKSPACE_IMAGE}${selectedWorkspace.payment_screenshot}`,
                      );
                      setShowPaymentModal(true);
                    }}
                  >
                    <img
                      src={`${UPLOADS.WORKSPACE_IMAGE}${selectedWorkspace.payment_screenshot}`}
                      alt="payment"
                      style={{
                        maxWidth: "300px",
                        borderRadius: "10px",
                        border: "1px solid #ddd",
                        padding: "5px",
                        transition: "transform 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.05)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1)";
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <label>Payment Screenshot:</label>
                  <p>Not uploaded</p>
                </div>
              )}
            </div>

            {showPaymentModal && (
              <div
                className="image-modal-overlay"
                onClick={() => setShowPaymentModal(false)}
              >
                <div
                  className="image-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="image-close-btn"
                    onClick={() => setShowPaymentModal(false)}
                  >
                    ✖
                  </button>

                  <img
                    src={paymentImage}
                    alt="Payment Full"
                    className="full-payment-image"
                  />
                </div>
              </div>
            )}

            <div className="description-box">
              <label>Description</label>
              <p>{selectedWorkspace.description || "-"}</p>
            </div>

            <div className="popup-images">
              {selectedWorkspace.image &&
                selectedWorkspace.image
                  .split(",")
                  .map((img, i) => (
                    <img
                      key={i}
                      src={`${UPLOADS.WORKSPACE_IMAGE}${img.trim()}`}
                      alt="workspace"
                      style={{ cursor: "pointer", transition: "0.2s ease" }}
                      onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                      onMouseLeave={(e) => (e.target.style.opacity = "1")}
                      onClick={() => openCarousel(selectedWorkspace.image, i)}
                    />
                  ))}
            </div>

            <div className="modal-actions">
              {selectedWorkspace.status === "Active" ||
              selectedWorkspace.status === "Hidden" ? (
                ""
              ) : (
                <button
                  className="btn btn-success"
                  onClick={() => updateStatus("Active")}
                >
                  <i className="bi bi-check-lg"></i> Accept
                </button>
              )}

              {selectedWorkspace.status !== "Hidden" ? (
                <button
                  className="btn btn-warning"
                  onClick={() => updateStatus("Hidden")}
                >
                  <i className="bi bi-eye-slash"></i> Hide
                </button>
              ) : (
                <button
                  className="btn btn-info"
                  onClick={() => updateStatus("Active")}
                >
                  <i className="bi bi-eye"></i> Unhide
                </button>
              )}
              <button
                className="btn btn-danger"
                onClick={() => updateStatus("Rejected")}
              >
                <i className="bi bi-trash"></i> Reject & Delete
              </button>
              <button className="btn btn-secondary" onClick={handleClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* IMAGE CAROUSEL / SLIDING POPUP */}
      {showCarousel && carouselImages.length > 0 && (
        <div
          className="lightbox-overlay"
          onClick={() => setShowCarousel(false)}
        >
          <div
            className="carousel-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-btn"
              onClick={() => setShowCarousel(false)}
            >
              &times;
            </button>

            {carouselImages.length > 1 && (
              <button
                className="nav-btn nav-btn-left"
                onClick={handlePrevImage}
              >
                &#10094;
              </button>
            )}

            <img
              className="carousel-image"
              src={`${UPLOADS.WORKSPACE_IMAGE}${carouselImages[currentImageIndex]}`}
              alt={`Workspace Slide ${currentImageIndex}`}
            />

            {carouselImages.length > 1 && (
              <button
                className="nav-btn nav-btn-right"
                onClick={handleNextImage}
              >
                &#10095;
              </button>
            )}

            <div className="slides-counter">
              {currentImageIndex + 1} / {carouselImages.length}
            </div>
          </div>
        </div>
      )}

      {renewModal.open && (
        <div
          className="renewads-popup-overlay"
          onClick={() =>
            setRenewModal({
              ...renewModal,
              open: false,
            })
          }
        >
          <div
            className="renewads-popup-box"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="renewads-title">Renew Workspace Advertisement</h3>

            <div className="renewads-body">
              <label>Renew Days</label>
              <input
                type="number"
                min="1"
                className="renewads-input"
                value={renewModal.days}
                onChange={(e) =>
                  setRenewModal({
                    ...renewModal,
                    days: e.target.value,
                  })
                }
              />
            </div>
            <div className="renewads-body">
              <label>Renew Amount</label>
              <input
                type="number"
                className="renewads-input"
                value={renewModal.workspace?.ads_amount || ""}
                onChange={(e) =>
                  setRenewModal({
                    ...renewModal,
                    workspace: {
                      ...renewModal.workspace,
                      ads_amount: e.target.value,
                    },
                  })
                }
              />
            </div>
            <div className="renewads-footer">
              <button
                className="renewads-btn renewads-save"
                onClick={renewWorkspaceAdvertisement}
              >
                Renew
              </button>
              <button
                className="renewads-btn renewads-cancel"
                onClick={() =>
                  setRenewModal({
                    ...renewModal,
                    open: false,
                  })
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
